import { ApiGetRequest } from 'types';

export enum EUsersModals {
  CONFIRM = 'confirm',
  API_KEY = 'api_key',
  CHANGE_PASSWORD = 'change_password',
  BIND_COMPANIES = 'bind_companies',
  RESET_2FA = 'reset_2fa',
}

export enum EUsersModalAction {
  CREATE_API_KEY = 'create_api_key',
  REMOVE_API_KEY = 'remove_api_key',
  SHOW_API_KEY = 'show_api_key',
  DELETE = 'delete',
  CONFIRM_OTP = 'confirm_otp',
  SET_PASSWORD = 'change_password',
}

export interface UsersModalPayload {
  action?: EUsersModalAction;
  apiKey?: {
    token: string;
    created_at: string;
  };
}

export interface IUsersModal {
  type: EUsersModals;
  payload?: UsersModalPayload;
}

export interface GetUserPayload {
  id: number;
}

export interface RemoveUserPayload extends GetUserPayload {}

export interface FetchUsersPayload extends ApiGetRequest {
  filter_by_role_id?: number | null;
  filter_by_company_id?: number | null;

  order_by_email?: 'asc' | 'desc';
  order_by_username?: 'asc' | 'desc';
  order_by_company_name?: 'asc' | 'desc';
}

export interface BindUserCompaniesPayload {
  user_id: number;
  companies: number[];
}

export interface SwitchUserCompanyPayload {
  user_id: number;
  company_id: number;
}

export interface UpdateUserProfilePayload {
  user_id: number;
  first_name: string;
  last_name: string;
}

export interface CreateUserPayload {
  first_name: string;
  last_name: string;
  email: string;
  username: string;
  password: string;
  roles: number[];
  company_id: number;
  country_code: string;
  region_code: string;
  phone_number: string;
}

export interface UpdateUserPayload extends CreateUserPayload {
  id: number;
}

export interface CreateApiKeyResponse {
  token: string;
  created_at: string;
}
